import { createRouteRef } from '@backstage/core-plugin-api';

export const favoritesRouteRef = createRouteRef({
  id: 'confidence.favorites',
});
